"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhereConditionQueryBuilderPlugin = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const WhereSelector_1 = __importDefault(require("../selectors/WhereSelector"));
const QueryBuilderContext_1 = require("../QueryBuilderContext");
const StyledDiv = styled_components_1.default.div ``;
const WhereCondition = ({ andIndex, orIndex, params }) => {
    const { queryManager } = (0, QueryBuilderContext_1.useQueryBuilderContext)();
    return (react_1.default.createElement(StyledDiv, null,
        react_1.default.createElement(WhereSelector_1.default, { vertical: true, where: params || { type: orIndex === 0 ? 'simple' : 'or' }, onChange: where => {
                queryManager.updatePluginCondition(andIndex, orIndex, {
                    pluginType: 'WhereConditions',
                    conditionType: 'FieldFilters',
                    params: where
                });
            } })));
};
exports.WhereConditionQueryBuilderPlugin = {
    name: 'Where Conditions',
    type: 'WhereConditions',
    default: true,
    conditions: [
        {
            name: 'Field filters',
            type: 'FieldFilters',
            component: WhereCondition
        }
    ]
};
//# sourceMappingURL=WhereConditionQueryBuilderPlugin.js.map